import cls from "classnames";
import styles from "./index.module.scss";

type HeadingVariant = "heading-1" | "heading-2" | "heading-3" | "heading-4";
type SubtitleVariant = "subtitle-1" | "subtitle-2" | "subtitle-3" | "subtitle-4";
type LabelVariant = "label-1";
type BodyVariant = "body-1" | "body-2" | "body-3";
type CaptionVariant = "caption-1" | "caption-2";

type AllowedTags =
  | "span"
  | "div"
  | "p"
  | "li"
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "label";

type Props = {
  as?: AllowedTags;
  variant: HeadingVariant | SubtitleVariant | LabelVariant | BodyVariant | CaptionVariant;
  color?: string;
  align?: "left" | "center" | "right";
  children: React.ReactNode;
  className?: string;
  id?: string;
};

export default function Text(props: Props) {
  const { as: Component = "span", variant, children, className } = props;
  return (
    <Component
      className={cls(styles[variant], className)}
      style={{
        color: props.color,
        textAlign: props.align,
      }}
    >
      {children}
    </Component>
  );
}
